const ROOT_ID = 'root'

interface ScriptOptions {
  id?: string
  src?: string
  content?: string
  async?: boolean
  type?: string
}

export function injectScript(opts: ScriptOptions): HTMLScriptElement | null {
  const root = document.getElementById(ROOT_ID)
  if (!root) {
    console.warn(`No #${ROOT_ID} element found—cannot inject script.`)
    return null
  }

  const script = document.createElement('script')
  if (opts.id) script.id = opts.id
  script.type = opts.type ?? 'text/javascript'
  if (opts.src) {
    script.src = opts.src
    script.async = opts.async ?? false
  } else if (opts.content) {
    script.text = opts.content
  }

  root.appendChild(script)
  return script
}

export function injectStyle(css: string, id?: string) {
  const root = document.getElementById(ROOT_ID)
  if (!root) {
    console.warn(`No #${ROOT_ID} element found—cannot inject style.`)
    return
  }
  const style = document.createElement('style')
  if (id) style.id = id
  style.textContent = css
  root.appendChild(style)
}
